import { Container } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { SubmitButton } from "../../components/buttons/submit-button";
import { SubscriptionPlan } from "./types";
import { useIsMobile } from "../../hooks/use-is-mobile";
import { paymentSymbol } from "../subscription/utils";
import { useBranding } from "../../contexts/branding";
import i18n from "../../utils/i18n";
import { mixpanelTrack } from "../../utils/mixpanel-utils";

interface Props {
    plan: SubscriptionPlan;
    onSubscribe: () => void;
    isLoading: boolean;
}

export default function Footer({ plan, onSubscribe, isLoading }: Props) {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const { paymentTC, privacyUrl } = useBranding();

    let actionWord = "clicking";
    if (isMobile && i18n.language === "es") {
        actionWord = "tocando";
    } else if (isMobile) {
        actionWord = "tapping";
    }

    return (
        <Container
            className={`d-flex flex-column align-items-center justify-content-center mt-4 mb-3${
                isMobile ? " sticky-footer-mobile align-content-center" : ""
            }`}
            style={isMobile ? { zIndex: 1000 } : undefined}
        >
            <SubmitButton
                label={`${t("subscriptions.subscribe")} - ${
                    paymentSymbol[plan?.currency || "USD"]
                }${plan.amount}`}
                className={`min-width-250${isMobile ? " w-100" : ""}`}
                onClick={() => {
                    mixpanelTrack("Subscribe Button Click", {
                        step: "Subscription",
                        flow: "External Subscription",
                    });
                    onSubscribe();
                }}
                isSubmitting={isLoading}
            />
            <span
                className="text-muted small mt-1 w-100 text-center"
                style={{
                    color: "#333",
                    display: "block",
                    ...(isMobile ? { fontSize: "13px" } : {}),
                }}
            >
                <Trans
                    i18nKey="subscriptions.terms_external_subscription_link"
                    values={{ actionWord }}
                    components={{ b: <b /> }}
                />{" "}
                <a
                    href={
                        i18n.language === "es" ? `${privacyUrl}-es` : privacyUrl
                    }
                    rel="noreferrer"
                    target="_blank"
                    style={{ textDecoration: "underline", color: "#333" }}
                    onClick={() => {
                        mixpanelTrack("Privacy Policy Click", {
                            step: "Privacy Policy",
                            flow: "External Subscription",
                        });
                    }}
                >
                    {t("subscriptions.privacy_policy")}
                </a>
                <span style={{ marginRight: 3, marginLeft: 3 }}>
                    {t("And")}
                </span>
                <a
                    href={
                        i18n.language === "es" ? `${paymentTC}-es` : paymentTC
                    }
                    rel="noreferrer"
                    target="_blank"
                    style={{ textDecoration: "underline", color: "#333" }}
                    onClick={() => {
                        mixpanelTrack("Terms & Conditions Click", {
                            step: "Terms & Conditions",
                            flow: "External Subscription",
                        });
                    }}
                >
                    {t("subscriptions.terms_link")}
                </a>
            </span>
        </Container>
    );
}
